import React from 'react';
import IntlContext from './IntlContext';

const Currency = ({ value }) => {
  return (
    <IntlContext.Consumer>
      {({ currency }) => currency(value)}
    </IntlContext.Consumer>
  );
};

export default Currency;
